import * as React from "react";
import { Grid, Header, Icon, Popup, Segment } from "semantic-ui-react";
import { IconSizeProp } from "semantic-ui-react/dist/commonjs/elements/Icon/Icon";
export interface IItemContainer {
  size?: "small" | "medium" | "large";
  title: string;
  children: any;
  popupMessage?: string;
  styleContent?: any;
}

interface ISizeStyle {
  sizeHeader: "tiny" | "small" | "medium" | "large" | "huge";
  sizeIcon: IconSizeProp | undefined;
}

class ItemContainer extends React.Component<IItemContainer> {
  public render() {
    const { title, children, popupMessage, styleContent } = this.props;
    const sizeStyle = this.getSize();

    return (
      <Grid >
        <Grid.Row columns={popupMessage ? 2 : 1} verticalAlign="middle">
          <Grid.Column floated="left" textAlign="left" width={13}>
            <Header
              color="grey"
              size={sizeStyle.sizeHeader}
              style={styles.header}
            >
              {title}
            </Header>
          </Grid.Column>
          {popupMessage ? (
            <Grid.Column
              floated="right"
              textAlign="right"
              width={2}
              style={styles.columnPopup}
            >
              <Popup
                trigger={
                  <Icon
                    name="question circle"
                    color={"grey"}
                    size={sizeStyle.sizeIcon}
                    style={styles.icon}
                  />
                }
                content={popupMessage}
              />
            </Grid.Column>
          ) : null}
        </Grid.Row>
        <Grid.Row columns={1} style={{ ...styles.row }}>
          <Grid.Column>
            <Segment style={{ ...styleContent }}>{children}</Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  private getSize = () => {
    const { size } = this.props;
    const style: ISizeStyle = {
      sizeHeader: "medium",
      sizeIcon: "large",
    };
    switch (size) {
      case "small":
        style.sizeHeader = "tiny";
        style.sizeIcon = undefined;
        break;
      case "medium":
        style.sizeHeader = "medium";
        style.sizeIcon = undefined;
        break;
      case "large":
        style.sizeHeader = "large";
        style.sizeIcon = "big";
        break;
      default:
        style.sizeHeader = "medium";
        style.sizeIcon = "large";
        break;
    }
    return style;
  };
}

const styles = {
  row: {
    paddingTop: 0,
  },
  icon: {
    marginRight: 0,
  },
  header: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "90%",
  },
  columnPopup: {
    paddingLeft: 0,
  },
};

export default ItemContainer;
